import { Button, Grid, Text } from '@simplywallst/ui-core';
import Banding from './Banding';

interface Props {
  formattedValue: string | null;
  percentageDifference: number | null;
  isExistingNarrative: boolean;
  onboardingCompleted: boolean;
  showingOnboarding: () => void;
  editNarrative: () => void;
  createNarrative: () => void;
}

const NarrativeBuildFlow = ({
  formattedValue,
  percentageDifference,
  isExistingNarrative,
  onboardingCompleted,
  showingOnboarding,
  editNarrative,
  createNarrative,
}: Props) => {
  if (isExistingNarrative) {
    return (
      <Grid templateColumns="max-content max-content" gap="16px">
        <Button styleType="loudLarge" onClick={() => editNarrative()}>
          Edit Narrative
        </Button>
        {formattedValue !== null && percentageDifference !== null && (
          <Grid>
            <Text color="white" typography="small" textAlign="end">
              {formattedValue}
            </Text>
            <Banding value={percentageDifference} />
          </Grid>
        )}
      </Grid>
    );
  }

  return (
    <Button
      styleType="loudLarge"
      onClick={(event) => {
        if (onboardingCompleted) {
          event.preventDefault();
          event.stopPropagation();
          createNarrative();
        } else {
          showingOnboarding();
        }
      }}
    >
      Build my narrative
    </Button>
  );
};

export default NarrativeBuildFlow;
